import { render, staticRenderFns } from "./ImageMap.vue?vue&type=template&id=2590fb12&scoped=true"
import script from "./ImageMap.vue?vue&type=script&lang=js"
export * from "./ImageMap.vue?vue&type=script&lang=js"
import style0 from "./ImageMap.vue?vue&type=style&index=0&id=2590fb12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2590fb12",
  null
  
)

export default component.exports